import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

import EFProductWinAdd from '@/components/UI/svg/mm100/Icon/EFProductWinAdd';

import EFVideo from '@/components/UI/EFVideo';

export default function Comp({ callBack }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [videoEnterA, setVideoEnterA] = useState(false);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.listD1`,
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });
        sceneA1.on('leave', function () {
            setVideoEnterA(false);
        });

        AniContainer.addScene(sceneA1);
    }, []);

    const openAllWin = () => callBack('modal-listD1');

    return (
        <div className={`${css.listD} listD1`}>
            <div className="ms-box">
                <div className="ms-box-move">
                    <div className="kit-ms1">{t('presale.product.listD1_ms1')}</div>
                    <div className="kit-ms2">{t('presale.product.listD1_ms2')}</div>
                    <div className="kit-ms3">{t('presale.product.listD1_ms3')}</div>
                    <div className="more-win-fun more-win-fun1" onClick={openAllWin}>
                        {t('presale.product.listD1_btn1')}
                        <span className="more-win-fun-icon">
                            <EFProductWinAdd />
                        </span>
                    </div>
                </div>
            </div>
            <div className="kit-inter">
                <div className="kit-img">
                    {videoEnterA && <EFVideo loop={false} sources={['/video/mm100m/takeControl.webm', '/video/mm100/takeControl.mp4']} className="video" />}
                </div>
            </div>
        </div>
    );
}
